import { CALENDAR_VISITS_LOAD_ERROR, SCHEDULING_INCOMPLETE_LABEL } from "@shared/svrSchedulingIntegrity";

export function CalendarVisitsLoadError(props: { onRetry?: () => void }) {
  return (
    <div
      role="alert"
      className="rounded-md border border-red-300 bg-red-50 px-3 py-2 text-sm text-red-900"
    >
      <p className="font-semibold">{CALENDAR_VISITS_LOAD_ERROR}</p>
      {props.onRetry ? (
        <button
          type="button"
          className="mt-2 rounded border border-red-400 bg-white px-2 py-1 text-xs font-semibold"
          onClick={props.onRetry}
        >
          Retry
        </button>
      ) : null}
    </div>
  );
}

export function SchedulingIncompleteSection<
  T extends { id: number; visitNumber: string; technicianName?: string | null },
>(props: { visits: T[]; onOpen?: (id: number) => void }) {
  if (props.visits.length === 0) return null;
  return (
    <section
      aria-label={SCHEDULING_INCOMPLETE_LABEL}
      className="rounded-md border border-amber-300 bg-amber-50 px-3 py-2 text-sm text-amber-950"
    >
      <h2 className="font-semibold">{SCHEDULING_INCOMPLETE_LABEL}</h2>
      <p className="mt-1 text-xs">
        These visits have no valid scheduled time and are not shown on the time grid. Open the visit
        to set date and time. Duplicate attempts for the same customer/date must be reconciled by
        Admin — none are cancelled automatically.
      </p>
      <ul className="mt-2 space-y-1">
        {props.visits.map((v) => (
          <li key={v.id}>
            <button
              type="button"
              className="text-left font-medium underline"
              onClick={() => props.onOpen?.(v.id)}
            >
              {v.visitNumber}
              {v.technicianName ? ` — ${v.technicianName}` : ""}
            </button>
          </li>
        ))}
      </ul>
    </section>
  );
}
